import React from 'react';
import { makeStyles } from '@mui/styles'; // for custom styles (optional)
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const useStyles = makeStyles((theme) => ({
  // Optional: Define custom styles for the popup here
  // Example:
  // root: {
  //   backgroundColor: theme.palette.error.main,
  //   color: theme.palette.getContrastText(theme.palette.error.main),
  // },
}));

const MessageDialog = ({ message, open, onClose,severity }: any) => {
  const classes = useStyles(); // Get custom styles (optional)
    // console.log("rendering popup...");
  return (
    <Snackbar
      open={open}
      autoHideDuration={60000} // Hide after 6 seconds
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Top center position
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        severity={severity??"warning"} // Adjust severity as needed (e.g., "error")
        onClose={onClose}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default MessageDialog;
